import React from "react";
import { Button } from "@mui/material";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { useNavigate } from "react-router-dom";
import Flx from "../../../components/layout/Flx";
import Txt from "../../../components/typography/Txt";
import colors from "../../../theme/colors";
import { PANEL_BTN_OUTLINE_SX } from "../panelButtonStyles";
import {
  submissionBorrowerName,
  submissionToSendPrefill,
} from "../submissionHelpers";

/**
 * "Send this borrower another link" — straight from their expanded row, with
 * what they already told us carried across so the broker isn't retyping a name
 * and email off the screen in front of them.
 *
 * The prefill rides in router state (the same channel CreateLoanApplicationScreen
 * uses) rather than the query string: it's borrower PII, and a link kind's
 * allowlist decides what actually gets minted anyway.
 */
// The buttons name the DOCUMENT; the label to their left names the recipient.
// Repeating "Send" on each one only pushed the useful word further right.
const SEND_TARGETS = [
  { path: "/send/loan-application", label: "Loan Application" },
  { path: "/send/credit-auth", label: "Credit Authorization" },
];

const SendToBorrowerActions = ({ row, size = "small" }) => {
  const navigate = useNavigate();
  if (!row) return null;

  const borrowerPrefill = submissionToSendPrefill(row);
  const name = submissionBorrowerName(row);

  return (
    <Flx centerY wrap gap={0.75} sx={{ flexShrink: 0 }}>
      <Txt
        sx={{
          fontSize: 12.5,
          color: colors.slate500,
          whiteSpace: "nowrap",
          mr: "2px",
        }}
      >
        {name ? `Send To ${name}` : "Send To borrower"}
      </Txt>
      {SEND_TARGETS.map(({ path, label }) => (
        <Button
          key={path}
          size={size}
          variant="outlined"
          startIcon={<SendOutlinedIcon sx={{ fontSize: 15 }} />}
          onClick={() => navigate(path, { state: { borrowerPrefill } })}
          sx={PANEL_BTN_OUTLINE_SX}
        >
          {label}
        </Button>
      ))}
    </Flx>
  );
};

export default SendToBorrowerActions;
